import styled from 'styled-components';
import { Card, TextField, createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) =>
  createStyles({
    mb30: {
      'margin-bottom': '30px'
    },
    mb10: {
      'margin-bottom': '10px'
    }
  })
);

export const CardWrapper = styled(Card)`
  margin: 100px auto;
  width: 485px;
  border-radius: 15px;
  background-color: #ffffff;
  box-shadow: 0 12px 19px 0 rgba(60, 128, 209, 0.09);
  min-height: '435px';
`;

export const TextTitle = styled.p`
  color: #12253f;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 28px;
  font-family: 'TTCommons';
  margin-bottom: 30px;
  font-size: 17px;
`;

export const TextWrapper = styled(TextField)`
  font-size: 17px;
  width: 100%;
  box-sizing: border-box;
`;

export const TextLabel = styled.p`
  color: #102341;
  font-family: 'TTCommons';
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 18px;
`;

export const CardTitle = styled.p`
  color: #12253f;
  font-family: 'TTCommons';
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 20px;
  text-align: center;
  margin-bottom: 20px;
`;

export const CenterRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

export const TextCenter = styled.p`
  color: #6e84a3;
  font-family: 'TTCommons';
  font-size: 15px;
  letter-spacing: 0;
  line-height: 18px;
  text-align: center;
`;

export const ButtonBackWrapper = styled.div`
  width: 50%;
`;
